import React, { Fragment } from "react";
import ResourcesContainer from "containers/ResourcesContainer";
import { shortLinkCheckoutPreview } from "components/FormerEditor/common/preview";
import CombinationCheckoutDetails from "../CombinationCheckoutDetails";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import compact from "lodash/compact";
import HoverIconButton from "components/HoverIconButton";
import { secondaryBackButton } from "utils/constants/ui";
import { useFormMergedShortLinkConfig } from "utils/hooks/manifest";
import Pill from "components/Pill";
import { STATUS, UI_THEME } from "utils/constants/ui";
import { STATE_KEYS } from "utils/constants/state";

const CombinationResult = ({ result, name }) => {
  const shortLink = useFormMergedShortLinkConfig(result);
  const primaries = get(shortLink, STATE_KEYS.SHORT_LINK.PRIMARIES) || [];
  const hasPrimaries = Array.isArray(primaries) && primaries.length > 0;

  return (
    <ResourcesContainer>
      {(resources) => {
        let content = null;

        const checkoutPreview = shortLinkCheckoutPreview({
          shortLink,
          ...resources
        });
        if (!isEmpty(result)) {
          content = (
            <CombinationCheckoutDetails
              collapseImages={checkoutPreview.collapseImages}
              {...checkoutPreview.checkout}
            />
          );
        } else {
          const buttonProps = secondaryBackButton({
            type: "right"
          });
          const prompt = compact([
            "Select",
            hasPrimaries ? "additional" : null,
            "products"
          ]).join(" ");
          content = (
            <Fragment>
              <div className="flex flex-row justify-between items-center">
                <div className="f6 fw5">{`${prompt}.`}</div>
                <HoverIconButton {...buttonProps} />
              </div>
              {hasPrimaries && (
                <div className="ba pa2 br2 hairline-1 mt3">
                  <div className="pb2">
                    <Pill
                      theme={UI_THEME}
                      status={STATUS.WARNING}
                      copy="Inherited"
                      customClasses={{
                        container: "flex w-100 items-end justify-end mr1",
                        copy: "f7 pa1 br2 fw6 flex-shrink-0 items-center"
                      }}
                    />
                  </div>
                  <CombinationCheckoutDetails
                    collapseImages={checkoutPreview.collapseImages}
                    {...checkoutPreview.checkout}
                  />
                </div>
              )}
            </Fragment>
          );
        }

        return content;
      }}
    </ResourcesContainer>
  );
};

export default CombinationResult;
